import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Hero, Section, SectionLabel, Band, Arrow } from "../components/Section";
import { RESEARCH_NOTES } from "../config/research";
import { MessagesSquare } from "lucide-react";
import { EditorialIcon, ArchitectureIllustration } from "../components/EditorialVisuals";
import { ResearchFlow } from "../components/EditorialDiagrams";

const LEAD =
  "What we are learning as we build Aky and as enterprises adopt AI, published as we learn. Our research contextualises AI for local use: benchmarks, training material and evidence for executives in Africa and other emerging markets.";

const NOTE_ILLUSTRATIONS = {
  "data-governance-debt": "insulation",
  "too-many-pilots": "leadership",
};

export default function Research() {
  return (
    <>
      <Seo title="Research — Syni.ai" description={LEAD} path="/research" />
      <Hero title="Research" lead={LEAD} testId="research-hero" />

      <section className="section" style={{ paddingTop: 0 }} data-testid="research-debate">
        <div className="container-syni">
          <div className="debate">
            <div>
              <EditorialIcon icon={MessagesSquare} className="editorial-debate-icon" testId="research-debate-icon" />
              <SectionLabel>The Executive Debate</SectionLabel>
              <h2 className="h-section" style={{ marginTop: 20 }}>
                2026 Kenya Edition
              </h2>
            </div>
            <div className="prose body-copy">
              <p>
                Convened with Aspen Initiative Nairobi and ICC Kenya on 13 October 2026. The room was polled before and after on one question:
                should enterprises accelerate AI adoption and manage governance in flight, or build governance foundations before capital
                scales? The before-and-after result will be published here as the first data point of the series.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Section n="01" label="What we are learning · 2026" pale testId="research-notes">
        <div className="grid-cards grid-cards--3" data-testid="research-note-cards">
          {RESEARCH_NOTES.map((n, i) => (
            <Link key={n.slug} to={`/research/${n.slug}`} className="card card--link research-note-card" data-testid={`note-card-${n.slug}`}>
              <ArchitectureIllustration kind={NOTE_ILLUSTRATIONS[n.slug] || "research"} className="research-note-art" testId={`research-illustration-${n.slug}`} />
              <span className="mono-label">
                Note {i + 1} · {n.year}
              </span>
              <h3 className="card-title">{n.title}</h3>
              <p className="card-body">{n.summary}</p>
              <span className="card-foot link-arrow">
                <Arrow /> Read more
              </span>
            </Link>
          ))}
        </div>
      </Section>

      <Section n="02" label="Where the research goes" split testId="research-goes" below={<ResearchFlow testId="research-output-diagram" />}>
        <p className="body-copy measure">
          Syni.ai research feeds three things: the gates built into Aky, the curriculum of Lead.ai, and the benchmarks executives use to judge
          their own readiness. It is published openly.
        </p>
      </Section>

      <Band label="To discuss a research collaboration" links={[{ to: "/contact", label: "Contact", testId: "research-close-contact" }]} testId="research-close" />
    </>
  );
}
